// core
import React, { useState } from "react";
import { IFinancialStrengthRating } from "../../../../interfaces/IFinancialStrengthRating";
import FinancialStrengthModal from "../../../Modals/FinancialStrengthModal/FinancialStrengthModal";

// interfaces
interface IQuoteTableFinancialStrengthCellProps {
    providerRating: IFinancialStrengthRating;
    providerName: string;
    providerId: number;
}

// rendering
const QuoteTableFinancialStrengthCell: React.FC<IQuoteTableFinancialStrengthCellProps> = (
    props
) => {
    const { providerRating, providerName, providerId } = props;

    const [isOpenFinancialStrengthModal, setIsOpenFinancialStrengthModal] = useState(
        false
    );
    return (
        <React.Fragment>
            <FinancialStrengthModal
                providerName={providerName}
                providerId={providerId}
                providerRating={providerRating}
                isOpen={isOpenFinancialStrengthModal}
                onClose={(): void => {
                    setIsOpenFinancialStrengthModal(false);
                }}
            />
            <div className="layout-flex-column--centered">
                <span className="text-large">{providerRating.rating}</span>
                <span>{providerRating.ratingAgency}</span>
                <a onClick={() => setIsOpenFinancialStrengthModal(true)}>Learn More</a>
            </div>
        </React.Fragment>
    );
};

export default React.memo(QuoteTableFinancialStrengthCell);
